//#region Role/Status Selection code

export enum filterType {
  Family = 1,
  Individual = 2,
}
